import { render, staticRenderFns } from "./LegendaryBinding.vue?vue&type=template&id=616d3dfe&scoped=true"
import script from "./LegendaryBinding.vue?vue&type=script&lang=js"
export * from "./LegendaryBinding.vue?vue&type=script&lang=js"
import style0 from "./LegendaryBinding.vue?vue&type=style&index=0&id=616d3dfe&prod&lang=css"
import style1 from "./LegendaryBinding.vue?vue&type=style&index=1&id=616d3dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616d3dfe",
  null
  
)

export default component.exports